<template>
  <div id="app">


    <router-view />
  </div>
</template>
<script>
export default {
  name: 'App',

}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;

}

*, *::before, *::after {
  box-sizing: border-box;
}

html, body {
  overflow-x: hidden; 
  width: 100%;
  margin: 0;
  padding: 0;
}
</style>
